import React from 'react';
import { compose } from 'recompose';
import styles from '../../../styles/widgets/digital-coach-dashboard.module.scss';
import { DigitalCoachWidget } from '../../../widgets/digital-coach-widget';
import { THeadline } from '../../../components/template';
import { withWidgetController } from '../components/with-controller';
import { withGridContext } from '../components/with-grid';
import { withWidgetTracking } from '../hocs/with-widget-tracking';

const Widget = React.memo(({ title, subtitle, widgetIdentifier, pageIdentifier, order }) => (
  <>
    <THeadline title={title} subtitle={subtitle} />
    <DigitalCoachWidget order={order} widgetIdentifier={widgetIdentifier} pageIdentifier={pageIdentifier} />
  </>
));

export const DigitalCoach = compose(
  withWidgetController({ className: styles.container }),
  withGridContext,
  withWidgetTracking
)(Widget);
